/**
 * @module app.pp
 */

import { autoinject, bindingMode } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import { IWizardStep } from 'app/core/components/wizard/interfaces';
import { NoteService } from 'app/core/services/note-service';
import { focusFirst } from 'app/shared/lib/focus';
import { apiCall } from 'app/shared/lib/essette-api';
import { INotesConfig } from 'app/core/models/essette-interfaces';
import { AuthContext } from 'app/um/lib/auth-context';
import { WizardNavigator } from 'app/core/components/wizard/wizard-navigator';
import * as UM from 'app/um/models/essette-api';


@autoinject()
export class NoteStep extends ComponentBase implements IWizardStep {

    ////****************** Fields and Properties ************************************////

    @bindable.object({ defaultBindingMode: bindingMode.twoWay })
    protected auth: UM.Auth = {};

    public canSkip: boolean = false;
    public canContinue: boolean = false;
    public canPerformFinalSubmit: boolean = true;

    protected noteCategory: UM.AuthNoteCategory | null = null;
    protected additionalInfoText: string | null = null;

    protected notesConfig: INotesConfig = {
        serviceRootUrl: 'um/auths',
        targetType: 'UM.Auth',
        moduleCode: 'UM',
        addTargetProperty: (note: UM.AuthNote) => { note.auth = { id: this.auth?.id } },
        excludeSystem: false
    }

    ////****************** Element References ***************************************////

    ////****************** Lifecycle events (in order of execution) *****************////

    constructor(
        private $element: Element,
        private readonly context: AuthContext,
        private readonly noteService: NoteService,

        ...rest: any[]) {
        super(...rest);
        this.logger.source = this;
        this.noteService.configure(this.notesConfig);
    }

    protected bind(bindingContext: Object, overrideContext: Object): void {
        this.loadNoteCategory();
    }

    ////****************** Functions ************************************************////

    public skipStep(): void { }

    public continueStep(): void { }

    public openStep(): void {
        setTimeout(() => focusFirst(this.$element), 250);
    }

    public async closeStep(): Promise<void> { }

    public async finalSubmit(wizard: WizardNavigator): Promise<void> {
        this.context.auth.notes = [{ category: this.noteCategory, text: this.additionalInfoText }];
        if(wizard) wizard.finalSubmit(true, this.context.auth);
    }

    ////****************** Service Calls ********************************************////

    @apiCall
    protected async loadNoteCategory(): Promise<void> {
        try {
            this.state.beginSave();

            const response = await this.noteService.loadCategoryByCode('ESSETTE:PP.UM.Auth.NewServiceRequested', {}, false, ['flags']);
            this.noteCategory = response.results[0];

        }
        catch(error) {
            throw error;
        }
        finally {
            this.state.endSave();
        }
    }

}
